import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { getPaAnanlyzeTeamListService } from '../../_services/Analyze/getPaAnanlyzeTeamList.service';

export const getPaAnanlyzeTeamListAction = {
    getPaAnanlyzeTeamListDataAction
}


function getPaAnanlyzeTeamListDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        getPaAnanlyzeTeamListService.getPaAnanlyzeTeamListServiceData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                    // callBack != undefined ? callBack(error) : null
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_PA_ANA_TEAM_LIST } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_PA_ANA_TEAM_LIST, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_PA_ANA_TEAM_LIST, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/getPaAnanlyzeTeamList.action.js